
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

type FeedbackSearchProps = {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  sortOption?: "newest" | "popular";
  setSortOption?: (option: "newest" | "popular") => void;
};

const FeedbackSearch = ({ 
  searchQuery, 
  setSearchQuery,
  sortOption,
  setSortOption
}: FeedbackSearchProps) => {
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <Input
        type="text"
        placeholder="Search feedback..."
        value={searchQuery}
        onChange={handleSearch}
        className="pl-9 w-full"
      />
    </div>
  );
};

export default FeedbackSearch;
